import { useContext } from "react"

import { useCurrentUser, useWorkflow } from "web/hooks/data"
import { TLOContext } from "web/contexts"

import {
  haveIntersection,
  daysFromToday,
  sortByKey,
} from "web/services/helpers"

import useCurrentStageIncompleteTasks from "./useCurrentStageIncompleteTasks"

function isUpcoming(task) {
  const days = daysFromToday(task.activity_date)
  return days >= 0 && days <= 7
}

function isOverdue(task) {
  return daysFromToday(task.effective_due_date) < 0
}

export default function useUpcomingAndOverdueTasks() {
  const currentUser = useCurrentUser()
  const { data: deal } = useContext(TLOContext)
  const workflow = useWorkflow(deal.workflow_id)

  const { tasks } = useCurrentStageIncompleteTasks()

  if (!workflow) {
    return {
      workflow,
      overdueTaskCount: 0,
      tasks: {},
    }
  }
  const userRoleIds = currentUser.business_roles.map((br) => br.id)

  const userTasks = tasks.filter(
    (task) =>
      haveIntersection(
        task.assignees.map((a) => a.assignee_id),
        userRoleIds
      ) && task.activity_date
  )

  const overdueTasks = userTasks.filter(isOverdue)
  const upcomingTasks = userTasks.filter(isUpcoming)

  return {
    workflow,
    overdueTaskCount: overdueTasks.length,
    tasks: sortByKey([...overdueTasks, ...upcomingTasks], "activity_date"),
  }
}
